import { createModule } from '@interhyp/platform-module';
import { RouteContext, routeExtension } from '@interhyp/platform-router';
import { lazy } from 'react';

export default createModule({
  name: 'portal-interim-home-intent-redirect',
  extensions: [
    routeExtension.createExtension({
      path: '/vorhaben-neu',
      context: RouteContext.MORTGAGE,
      component: lazy(() => import('./IntentRedirect.route')),
    }),
  ],
});
